import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { ErrorCircleIcon } from '@app-velocity/icons';
import { Typography } from '@app-velocity/ui';

const StatusIcon = styled('div')(({ theme }) => ({
  svg: {
    width: theme.spacing(40),
    height: theme.spacing(40),
    fill: 'var(--error-error-icon-secondary-color)'
  },
}));

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledTitle = styled(Typography)({
  fontSize: 48,
  lineHeight: 1,
  fontWeight: 500,
});

export const PaymentFailed = () => {
  const { t } = useI18n();

  return (
    <StyledContainer>
      <StatusIcon>
        <ErrorCircleIcon />
      </StatusIcon>
      <StyledTitle component="h1">
        {t('payments:status.fail.title')}
      </StyledTitle>

      <Typography variant="body1">{t('payments:status.fail.text')}</Typography>

      <Typography variant="body1">{t('payments:status.can_close')}</Typography>
    </StyledContainer>
  );
};
